// リーグフォームのフロントエンドバリデーション
// is-invalid + invalid-feedback パターンでインラインエラーを表示

(function () {
  'use strict';

  function findOrCreateFeedback(input, className) {
    let feedback = input.parentElement && input.parentElement.querySelector('.' + className + '.invalid-feedback');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'invalid-feedback ' + className;
      input.insertAdjacentElement('afterend', feedback);
    }
    return feedback;
  }

  function showError(input, className, message) {
    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    var feedback = findOrCreateFeedback(input, className);
    feedback.textContent = message;
  }

  function clearError(input, className) {
    input.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');
    var feedback = input.parentElement && input.parentElement.querySelector('.' + className + '.invalid-feedback');
    if (feedback) {
      feedback.textContent = '';
    }
  }

  function validateName(input, msgs) {
    var value = (input.value || '').trim();
    if (value.length === 0) {
      showError(input, 'js-league-name-error', msgs.nameRequired);
      return false;
    }
    if (value.length > 20) {
      showError(input, 'js-league-name-error', msgs.nameTooLong);
      return false;
    }
    clearError(input, 'js-league-name-error');
    return true;
  }

  function validateTitleMinimumMatches(input, msgs) {
    if (input.disabled) return true;

    var value = input.value;
    if (value === '' || value === null) {
      showError(input, 'js-title-min-matches-error', msgs.titleMinInvalid);
      return false;
    }
    var num = Number(value);
    if (!Number.isInteger(num) || num < 0) {
      showError(input, 'js-title-min-matches-error', msgs.titleMinInvalid);
      return false;
    }
    if (num > 999) {
      showError(input, 'js-title-min-matches-error', msgs.titleMinMax);
      return false;
    }
    clearError(input, 'js-title-min-matches-error');
    return true;
  }

  function initLeagueTypeToggle(form) {
    var radios = form.querySelectorAll('input[name="league[league_type]"]');
    var hints = form.querySelectorAll('.js-league-type-hint');
    if (!radios.length) return;

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var isTeam = radio.value === 'team';
        hints.forEach(function(hint) {
          hint.style.display = isTeam ? '' : 'none';
        });
      });
    });
  }

  function init() {
    var form = document.getElementById('league-form');
    if (!form) return;
    if (form.dataset.leagueValidateBound === '1') return;
    form.dataset.leagueValidateBound = '1';

    var msgs = {
      nameRequired: form.dataset.validateNameRequired,
      nameTooLong: form.dataset.validateNameTooLong,
      titleMinInvalid: form.dataset.validateTitleMinInvalid,
      titleMinMax: form.dataset.validateTitleMinMax
    };

    initLeagueTypeToggle(form);

    var nameInput = form.querySelector('input[name="league[name]"]');
    var titleMinInput = form.querySelector('input[name="league[title_minimum_matches]"]');

    if (nameInput) {
      nameInput.addEventListener('input', function () { validateName(nameInput, msgs); });
      nameInput.addEventListener('blur', function () { validateName(nameInput, msgs); });
    }

    if (titleMinInput) {
      titleMinInput.addEventListener('input', function () { validateTitleMinimumMatches(titleMinInput, msgs); });
      titleMinInput.addEventListener('blur', function () { validateTitleMinimumMatches(titleMinInput, msgs); });
    }

    form.addEventListener('submit', function (event) {
      var allValid = true;

      if (nameInput && !validateName(nameInput, msgs)) {
        if (allValid) nameInput.focus();
        allValid = false;
      }

      if (titleMinInput && !validateTitleMinimumMatches(titleMinInput, msgs)) {
        if (allValid) titleMinInput.focus();
        allValid = false;
      }

      if (!allValid) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  document.addEventListener('turbolinks:load', init);
})();
